<!-- <div *ngIf="isHeader"class="container-fluid documents">
    <div class="row">
        <div class="col-sm-12 compswitch ">

          <div class="switch  cswitch">
            <a href="javascript:void(0);" class="docOption doc-option upload" routerLink="/document/upload/firm">Upload</a> 
            <a href="javascript:void(0);" class="docOption doc-option view" routerLink="/document/view/firm">View</a>
          </div>

        </div>
    </div>
</div>

<router-outlet (activate)="onActivate($event)" ></router-outlet> -->


<div *ngIf="isHeader"class="container-fluid documents">
    <div class="row">
        <div class="col-sm-12 compswitch ">

          <div class="switch  cswitch">
            <a href="javascript:void(0);" class="docOption doc-option upload" routerLink="/document/upload/firm">Upload</a> 
            <a href="javascript:void(0);" class="docOption doc-option view" routerLink="/document/view/firm">View</a>
          </div>

          
          <div class="switch  cswitch cswitchtwo" *ngIf="role==='SU' && docCategory === 'view'">
            <!-- <a href="javascript:void(0);" class="details doc-option client " (click)="gotoDetail('client')">Client</a> -->
            <a href="javascript:void(0);" class=" details doc-option firm delFirm" [ngClass]="{'delFirm': docCategory === 'view' && role==='SU'}" (click)="gotoDetail('firm')">Practice</a>
            <a href="javascript:void(0);" class=" details doc-option delete delDelete" (click)="gotoDetail('delete');redelete()" *ngIf="docCategory === 'view' && role==='SU'">Deleted</a>
          </div>

        </div>
    </div>
</div>
<router-outlet (activate)="onActivate($event)" ></router-outlet> 
